import AppBar from '@material-ui/core/AppBar';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MaterialToolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import { EXPLORA_ROUTES } from 'app/explora-routes';
import { NavigationRoutesInterface } from 'domain/navigation-routes';
import useWindowSize from 'hooks/useWindowSize';
import React, { Dispatch, ReactNode, SetStateAction, useEffect, useRef } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { FontSize } from 'shared/styles/typography';
import ClickableIcon from '../ClickableIcon/ClickableIcon';
import DynamicImage from '../DynamicImage/DynamicImage';
import DynamicImageIcon from '../DynamicImageIcon/DynamicImage';
import TextBody from '../TextBody/TextBody';
import './Toolbar.scss';

interface ToolbarInterface {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  routes: NavigationRoutesInterface[];
  headerImage: string;
  children: ReactNode;
}

const Toolbar = ({ isOpen, setIsOpen, headerImage, routes, children }: ToolbarInterface) => {
  const history = useHistory();
  const { isNotTablet, isLTLaptop } = useWindowSize();
  const drawerRef = useRef<any>();
  const iconRef = useRef<any>();

  useEffect(() => {
    const closeDrawerOnOutsideClick = (event: MouseEvent) => {
      if (
        isOpen &&
        drawerRef.current &&
        !drawerRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen && !isLTLaptop) {
      setIsOpen(false);
    }

    document.addEventListener('mousedown', closeDrawerOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeDrawerOnOutsideClick);
  }, [isOpen, setIsOpen, isLTLaptop]);

  return (
    <div>
      <AppBar className="toolbar-container__app-bar">
        <MaterialToolbar classes={{ regular: 'toolbar-container__app-bar-regular' }}>
          {isNotTablet ? (
            <>
              <ClickableIcon ariaLabel="explora logo" onClick={() => history.push(EXPLORA_ROUTES.Home)} style={{ marginLeft: '1.5rem' }}>
                <DynamicImageIcon className="toolbar-container__header-logo" imageName={headerImage} alt="" />
              </ClickableIcon>
              <div className="toolbar-container__link-container">
                {routes.map(({ label, path }) => (
                  <NavLink key={path} to={path} className="toolbar-container__link" activeClassName="toolbar-container__active-link">
                    <TextBody component="span" size={FontSize.Small}>
                      {label.toUpperCase()}
                    </TextBody>
                  </NavLink>
                ))}
              </div>
            </>
          ) : (
            <>
              <IconButton
                color="inherit"
                aria-label="open menu"
                onClick={() => setIsOpen(!isOpen)}
                className="toolbar-container__menu-button"
                ref={iconRef}
              >
                <MenuIcon fontSize="large" />
              </IconButton>
              <ClickableIcon ariaLabel="explora logo" onClick={() => history.push(EXPLORA_ROUTES.Home)}>
                <DynamicImageIcon className="toolbar-container__header-logo" imageName={headerImage} alt="" />
              </ClickableIcon>
            </>
          )}
        </MaterialToolbar>
      </AppBar>
      <Drawer className="toolbar-container__drawer" ref={drawerRef} variant="persistent" anchor="left" open={isOpen}>
        <div className="toolbar-container__drawer-header"></div>
        {children}
      </Drawer>
    </div>
  );
};

export default Toolbar;
